import React from 'react'
import { CostCategory } from '../../api/schemas/schema'
import { translateEnumValue } from '../../helpers/enumHelper'
import { Badge } from '@fluentui/react-components'
import { getRiskEconomyColors } from '../../helpers/riskEconomyHelper'

type BadgeCostCategoryProps = {
   category: CostCategory
}
export const BadgeCostCategory = ({ category }: BadgeCostCategoryProps) => {
   return (
      <Badge appearance="filled" shape="rounded" style={{ backgroundColor: getRiskEconomyColors(category), width: '160px' }} size="large">
         {translateEnumValue(CostCategory, category)}
      </Badge>
   )
}
